export function buildLoginRedirectUrl(currentAttemptedUrl: string, lastUserLoginBrand?: string | null): string {
    // currentAttemptedUrl is the URL the user was trying to access, e.g., /messages?c=BRAND
    // This will become the 'redirect' parameter after login.
    // It might also contain the 'c' parameter.
    const url = new URL(currentAttemptedUrl, window.location.origin);
    let cParam = url.searchParams.get('c'); // Check if 'c' is in the attempted URL first

    if (!cParam && lastUserLoginBrand) {
        // If not in URL, use from localStorage, if exists
        cParam = lastUserLoginBrand;
    }

    const pathname = url.pathname; // Gets the path part of the currentAttemptedUrl (e.g., /messages)

    const cleanedRedirectParams = new URLSearchParams(url.search); // Gets all parameters of currentAttemptedUrl
    cleanedRedirectParams.delete('c'); // 'c' will be a direct param of /login, not part of 'redirect'. Remove
    const hasOtherParamsForRedirect = cleanedRedirectParams.toString() !== ''; // Remaining parameters of currentAttemptedUrl after removing 'c'

    // redirectToValue is the path and query params (without 'c') of the original attempted URL
    const redirectToValue = pathname + (hasOtherParamsForRedirect ? `?${cleanedRedirectParams.toString()}` : '');
    const shouldAddRedirectParam = redirectToValue !== '/' && redirectToValue !== '/login';

    const loginParams = new URLSearchParams();
    if (cParam) {
        loginParams.set('c', cParam);
    }
    if (shouldAddRedirectParam) {
        loginParams.set('redirect', redirectToValue);
    }

    const loginUrl = `/login${loginParams.toString() ? `?${loginParams.toString()}` : ''}`;

    return loginUrl;
}
